// extracted by mini-css-extract-plugin
module.exports = {"fader":"FadeScroller-styles-module--fader--Ftdsh","scroller":"FadeScroller-styles-module--scroller--j48rQ"};